import React from "react";

interface ExperieinceIconIntRevProps {
  width?: string;
  height?: string;
  isActive?: boolean;
}

const ExperieinceIconIntRev: React.FC<ExperieinceIconIntRevProps> = ({
  width = "24px",
  height = "24px",
  isActive = false,
}) => {
  const fillColor = `var(--${isActive ? "theme-primary-color" : "theme-inactive-color"})`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? "16"}
      height={height ?? "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 0.75L9.75 6.25H15.25L10.75 9.75L12.25 15.25L8 11.75L3.75 15.25L5.25 9.75L0.75 6.25H6.25L8 0.75Z"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        // style={{ fill: fillColor }}
      />
    </svg>
  );
};

export default ExperieinceIconIntRev;
